import React from 'react';
import styled from 'styled-components';
import SectionTitle from '@flow/scenes/home/components/section-title/SectionTitle';
import em from 'polished/lib/helpers/em';
import BasicButton from "@flow/components/ui/button/BasicButton";
import { Link } from "react-router-dom";
import { getRelativeUrl, rewriteNewsUrl } from '@flow/utils/cleaners';
import { IPosts } from 'types/IPosts';
import { IPost } from 'types/IPost';
import Moment from "react-moment";

const NewsListItem = styled.li`
  a {
    display: block;
    padding: 3em 15.6em;
    border-bottom: 0.1em solid ${props => props.theme.highlightColor};
    
    &:${props => props.theme.hoverProperty} {
      background-color: ${props => props.theme.highlightColor};
    }
    
    @media (max-width: 1920px) {
      padding-left: ${156 / (1920 * 0.01)}vw;
      padding-right: ${156 / (1920 * 0.01)}vw;
    }
  }
  
  time {
    text-transform: uppercase;
    font-size: 2.4em;
    font-family: Flow-Poster-Bold;
    
    @media (max-width: 1920px) {
      font-size: ${24 / (1920 * 0.01)}vw;
    }
    
    @media (max-width: 1200px) {
      font-size: ${34 / (1920 * 0.01)}vw;
    }
    
    @media (max-width: 700px) {
      font-size: ${44 / (1920 * 0.01)}vw;
    }
    
    @media (max-width: 550px) {
      font-size: ${77 / (1920 * 0.01)}vw;
    }
  }
`;

const NewsLabel = styled.span`
  display: block;
  font-size: 5.3em;
  line-height: 1.5;
  margin-top: ${em(3, 5.3)};
  
  @media (max-width: 1920px) {
    font-size: ${53 / (1920 * 0.01)}vw;
    margin-top: ${30 / (1920 * 0.01)}vw;
  }
  
  @media (max-width: 700px) {
    font-size: ${73 / (1920 * 0.01)}vw;
    margin-top: ${50 / (1920 * 0.01)}vw;
  }
  
  @media (max-width: 550px) {
    font-size: ${100 / (1920 * 0.01)}vw;
    margin-top: ${77 / (1920 * 0.01)}vw;
  }
`;

const AllNewsLink = styled.div`
  text-align: right;
  margin-top: 3em;
  padding: 0 3em;
`;

interface Props {
  appLanguage: IAppLanguage;
  recent_news?: {
    title?: string;
  }
  news?: IPosts;
}

const NewsLift = ({
  appLanguage,
  recent_news,
  news,
}: Props) => {

  const {
    title,
    lift_cta_group: {
      label,
      link
    }
  } = recent_news;

  return (
    <div>
      {Boolean(title) && <SectionTitle title={title}/>}
      {Array.isArray(news) &&
      <ul>
        {news.map((item: IPost, index: number) =>
          <NewsListItem key={index}>
            <Link to={getRelativeUrl(item.link)}>
              <Moment locale={appLanguage.code} date={item.date} format={'MMM Do YYYY'}/>
              <NewsLabel>{item.title}</NewsLabel>
            </Link>
          </NewsListItem>
        )}
      </ul>
      }
      <AllNewsLink>
        <BasicButton label={label} href={link.url}/>
      </AllNewsLink>
    </div>
  )
};

export default NewsLift;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/news-lift/NewsLift.tsx